module.exports = __webpack_public_path__ + "img/start-btn1.cbb2a92f.png";